/**
 * indiaLocations.js
 * Single source of truth for India States + Districts.
 * Uses `india-state-district` npm package for accurate district data.
 *
 * Exports:
 *   INDIA_STATES  — sorted array of { value: stateName, label: stateName, isoCode }
 *   getCities(stateName) — sorted array of { value, label } for that state
 */
import { getAllStates, getDistricts } from "india-state-district";

const rawStates = getAllStates();

/** All Indian States & UTs — sorted alphabetically, react-select format */
export const INDIA_STATES = rawStates
  .map((s) => ({ value: s.name, label: s.name, isoCode: s.code }))
  .sort((a, b) => a.label.localeCompare(b.label));

/**
 * Given a state name (e.g. "Bihar"), returns all its districts
 * as sorted react-select options.
 */
export function getCities(stateName) {
  if (!stateName) return [];

  // Find the state isoCode from name
  const state = INDIA_STATES.find((s) => s.value === stateName);
  if (!state) return [];

  const districts = getDistricts(state.isoCode);
  if (!districts || districts.length === 0) {
    // Fallback
    return [{ value: stateName, label: stateName }];
  }

  return districts
    .map((d) => ({ value: d, label: d }))
    .sort((a, b) => a.label.localeCompare(b.label))
    .filter(
      (district, idx, arr) =>
        idx === 0 || district.value !== arr[idx - 1].value // deduplicate
    );
}
